const createId = () => (
  Math.random().toString().slice(2)
)

export const createUniqueId = (extantIds) => {
  let id

  do {
    id = createId()
  } while (extantIds.includes(id))

  return id
}

export default createId
